// Campus photo for /colleges/villanova-university: CC BY-SA 4.0, by Sofia j, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AVillanova_University_Kyrka.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/villanova-university/; credited under the photo.
const photo = {
    "slug": "villanova-university",
    "alt": "The twin spires of the Church of St. Thomas of Villanova against a deep blue sky on Villanova University's campus",
    "src": "/colleges/villanova-university/campus-1600.webp",
    "srcSmall": "/colleges/villanova-university/campus-800.webp",
    "srcMid": "/colleges/villanova-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/villanova-university/og.jpg",
    "title": "Villanova University Kyrka",
    "author": "Sofia j",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AVillanova_University_Kyrka.jpg",
    "read": "2026-10-02"
};

export default photo;
